module.exports = __webpack_public_path__ + "img/gift4.f8e4a431.png";